import ThumbnailControlsMultiContainer from './ThumbnailControlsMultiContainer';

export default ThumbnailControlsMultiContainer;